import { render } from "./SuperAdminTemplateEvent.vue?vue&type=template&id=b2c5fbb0&scoped=true"
import script from "./SuperAdminTemplateEvent.vue?vue&type=script&lang=js"
export * from "./SuperAdminTemplateEvent.vue?vue&type=script&lang=js"

import "./SuperAdminTemplateEvent.vue?vue&type=style&index=0&id=b2c5fbb0&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2c5fbb0"]])

export default __exports__